<script setup lang="ts">
import { ref, computed } from 'vue'

const props = withDefaults(defineProps<{
  isOpenDefault?: boolean
  contentId: string
  addClass?: string
  addClassContent?: string
  addDataTc?: string
  controlStyle?: 'small' | 'large'
  label?: string
  contentAlign?: 'center' | null
  controlBorder?: 'none' | 'top'
}>(), {
  isOpenDefault: false,
  addClass: '',
  addClassContent: '',
  addDataTc: '',
  controlStyle: 'small',
  label: '',
  contentAlign: null,
  controlBorder: 'top'
})

const isOpen = ref(props.isOpenDefault)

const computedAriaLabel = computed(() => `: ${props.label} ${isOpen.value ? 'schließen' : 'öffnen'}`)

const toggle = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div class="bx-collapsible__control"
       :class="[
         addClass,
         {
           'bx-js-collapsible-open': isOpen,
           [`bx-collapsible__control--border-${controlBorder}`]: controlBorder !== 'none',
           'bx-collapsible__control--large': controlStyle === 'large'
         }
       ]"
       :data-tc="addDataTc"
       tabindex="0"
       role="button"
       :aria-label="computedAriaLabel"
       :aria-controls="contentId"
       :aria-expanded="isOpen"
       @click="toggle"
       @keyup.enter="toggle">
    <div class="bx-collapsible__label">
      <span>
        {{ label }}
      </span>
      <svg class="icon icon-arrow_toggle">
        <use href="#arrow_toggle" />
      </svg>
    </div>
  </div>
  <div v-show="isOpen"
       :id="contentId"
       class="bx-collapsible__content"
       :class="[addClassContent, {
         'bx-collapsible__content--centered': contentAlign === 'center',
         'bx-collapsible__content--large': controlStyle === 'large'
       }]"
       :aria-hidden="!isOpen">
    <slot name="content" />
  </div>
</template>
